<template>
    <div>
      <div class="full-screen" v-bind:style="{ backgroundImage: 'url(' + `${user.data.otherInfo['bg-img']}` + ')'}">
        <div class="home-donations app-bg-gradient">
          <div class="stars-bg"></div>
          <Languages class="languages" v-bind:settings="true"></Languages>
          <Timer></Timer>
          <div class="mosque-name">{{user.data.name}}</div>
          <div class="footer">{{"All Donations are Voluntary , T &amp; C applies" | translate}} </div>
          <div class="amount-details-section">
            <div>
              <div class="label">{{"Donation details" | translate}}</div>
              <div>
                <select v-model="donationName">
                  <option v-if="option.order !== 4" :key="option.title" v-for="option in user.data.donationCategories" :value="option.title">{{option.title | translate}}</option>
                  <optgroup v-if="option.order === 4" :key="option.title" v-for="option in user.data.donationCategories" :label="option.title | translate">
                      <option :key="category.title" v-for="category in option.childCategories" :value="category.title">{{category.title | translate}}</option>
                  </optgroup>
                </select>
                <div style="width:100%;position:relative">
                  <input type="number" id="input-amount" v-model="amount" @changedAmount="changedAmount" step="1" max="5000" />
                  <!-- <inputField id="input-amount" v-bind:value="amount" @changedAmount="changedAmount"></inputField> -->
                  <label for="input-amount" class="pound-symbol">&#163;</label>
                  <div class="error">&ensp;<span v-if="error">{{error | translate}}</span></div>
                </div>
              </div>
            </div>
            <div class="number-pad-section" v-if="amount !== null">
              <div class="label">{{"Enter your donation amount" | translate}}</div>
              <Numpad @change="changedAmount" :val="amount"/>
            </div>
          </div>
          <div class="other-donation-option">
            <div class="btn-bg1">
              <div class="btn-bg2">
                <button @click="donateAmount(amount)" class="cursor login">{{"Continue" | translate}}</button>
              </div>
            </div>
            <div class="btn-bg1">
              <div class="btn-bg2">
                <button @click="back" class="cursor login">{{"Back" | translate}}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  <!--<input v-model="amount" type="number" pattern="/d*"/>-->

<script>
import { mapGetters, mapActions } from 'vuex'
import InputField from './inputComponent.vue'
import Timer from './timer.vue'
import Languages from './Languages'
import Numpad from './numpad'

export default {
  data () {
    return {
      amount: null,
      tid: null,
      donationName: null,
      error: null,
      buttonName: null
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'token',
      'donationAmount',
      'donationType'
    ])
  },
  methods: {
    ...mapActions([
      'changeLoadingStatus',
      'changeDonationAmount',
      'changeDonationType',
      'changeDonationAmount'
    ]),
    changedAmount (a) {
      if (a > 5000) {
        this.amount = 5000
      } else {
        this.amount = +a
      }
    },
    back () {
      this.$router.go(-1)
    },
    donateAmount (a) {
      if (a !== null && a !== '' && a > 0) {
        // this.changeDonationAmount(+a)
        this.$router.push({path: `/${this.tid}/confirm/${this.donationType}/${this.amount}`})
      } else {
        if (a === 0) {
          this.error = 'Donation amount can\'t be 0'
        } else {
          this.error = 'Enter your donation amount'
        }
        setTimeout(() => {
          this.error = false
        }, 5000)
      }
    }
  },
  components: {
    InputField,
    Timer,
    Languages,
    Numpad
  },
  watch: {
    donationName (newValue) {
      this.changeDonationType(newValue)
    },
    amount (newValue) {
      this.changeDonationAmount(newValue)
    }
  },
  mounted: function () {
    this.donationName = this.$route.params.donationType
    this.amount = this.$route.params.donationAmount
    if (this.amount <= 0) {
      this.amount = ''
    }
    this.tid = this.$route.params.terminalId
    // if (this.$route.params.from === 'amount') {
    //   this.buttonName = 'Continue'
    // } else if (this.$route.params.from === 'confirm') {
    //   this.buttonName = 'Donate'
    //   this.amount = this.$route.params.donationAmount
    // }
    this.$nextTick(() => {
      // Check wether the user has been already logged in.
      if (!this.token) {
        this.$router.push({path: `/${this.tid}/`})
      } else {
        this.changeLoadingStatus(false)
      }
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .full-screen {
    background-position: center;
  }
  .home-donations {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
    height: 100vh;
    overflow: hidden;
  }
  .bg-img {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.9);
    transform: scaleX(-1);
  }
  .mosque-name {
    font-size: 40px;
    color: #FFF;
    font-family: "Lato";
    font-weight: bold;
    text-shadow: 1px 1.732px 4px rgba( 0, 0, 0, 0.45 );
    margin-top: 61px;
    margin-bottom: 50px;
    letter-spacing: 2px;
  }
  .amount-details-section {
    height: calc(100vh - 250px);
    width:80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .amount-details-section > div {
    width: 45%;
    height: 100%;
    background-color: rgba(255,255,255,0.15);
    padding: 5%;
  }
  .other-donation-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 100px;
  }
  .other-donation-option .btn-bg1 {
    margin-top: 0;
    z-index: 2;
    margin-right: 15px;
  }
  .label, .error {
    font-size: 25px;
    color: #880913;
    font-weight: 600;
    letter-spacing: 2px;
    margin-bottom: 50px;
  }
  .error {
    font-size: 16px;
    margin-bottom: 0;
    margin-top: 30px;
  }
  select, input {
    border: none;
    border-bottom: 1px solid #812d03;
    background-color: transparent;
    color: #FFF;
    font-size: 25px;
    outline: none;
    width:100%;
    height: 50px;
    padding: 0 10px;
    cursor: pointer;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin-bottom: 30px;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
  input {
    text-indent: 20px;
  }
  select option, select optgroup {
    margin: 40px;
    background: #ffffff;
    color: #000;
    text-shadow: 0 1px 0 rgba(0, 0, 0, 0.4);
  }
  .pound-symbol {
    position: absolute;
    font-size: 25px;
    color: #ffffff;
    top: 13px;
    left: 10px;
  }
  .keypad-button {
    background-image: url('/static/images/numpad-button.png');
    width: calc((100% / 3) - 10px);
    height: calc(100% / 4);
    background-size: 85%;
    background-position: center center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    font-size: 30px;
    font-weight: 600;
    cursor: pointer;
  }
  .number-pad-section {
    /* display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    position: relative; */
  }
  .back-arrow img {
    width: 40%;
  }
  .amount-details-section {
    z-index: 2;
  }
  .number-pad-section .label {
    margin-bottom: 20px;
  }
  div[dir='rtl'] select {
    background-position: 2% 60%;
    padding: 2% 4% 2% 10%;
    margin-left: 5%;
    margin-right: initial;
  }
  @media only screen and (min-width: 2000px) {
    .other-donation-option {
      height: initial;
    }
    .amount-details-section {
      height:43vh !important;
      width:85%;
      margin-top: 5%;
      margin-bottom: 5%;
    }
    .label, .error {
      font-size: 99px;
      margin-bottom: 15%;
      line-height: 80px;
    }
    select, input {
      font-size: 138px;
      height: auto;
      padding: 2%;
      background-position: 98% 60%;
      background-size: 70px;
    }
    .pound-symbol {
      font-size: 138px;
      line-height: 138px;
      top: 9%;
      left: 2%;
    }
    input {
      text-indent: 8%;
    }
    select {
      margin-bottom: 10%;
    }
    .amount-details-section > div {
      padding: 4% 3%;
    }
    .number-pad-section .label {
      margin-bottom: 3%;
    }
    .numpad-layour {
      height: 95%;
      margin-top: 5%;
    }
    .btn-bg1 {
      margin-top: 200px;
      z-index: 2;
      width: 620px !important;
      height: 200px !important;
      border-radius: 200px;
    }
    .btn-bg2 {
      width: 607px;
      height: 187px;
      border-radius: 200px;
    }
    button {
      width: 594px;
      height: 178px;
      border-radius: 200px;
      font-size: 70px;
      letter-spacing: 3px;
    }
  }

@media screen and (min-width: 1200px) and (min-height: 904px) {
  .btn-bg1 {
    width: 190px;
    height: 64px;
    min-height: 64px;
  }

  .btn-bg2 {
    width: 182px;
    height: 56px;
  }
  button.login {
    width: 180px;
    height: 54px;
    font-size: 20px;
  }
  .amount-details-section {
    height: 55vh;
  }
  .amount-details-section > div {
    height: 95%;
    padding: 4%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/amount-change.vue